/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

export type V2PollInstanceState =
  (typeof V2PollInstanceState)[keyof typeof V2PollInstanceState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V2PollInstanceState = {
  POLL_INSTANCE_STATE_PENDING: 'POLL_INSTANCE_STATE_PENDING',
  POLL_INSTANCE_STATE_READY: 'POLL_INSTANCE_STATE_READY',
  POLL_INSTANCE_STATE_FAILED: 'POLL_INSTANCE_STATE_FAILED',
  POLL_INSTANCE_STATE_UNKNOWN: 'POLL_INSTANCE_STATE_UNKNOWN',
} as const;
